import { jsx as _jsx } from "react/jsx-runtime";
export default function Badge({ children, variant = 'green' }) {
    const variants = {
        green: 'bg-primary-100 text-primary-800',
        blue: 'bg-accent-100 text-accent-800',
        gray: 'bg-gray-100 text-gray-800',
    };
    return (_jsx("span", { className: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variants[variant]}`, children: children }));
}
